<template>
    <div id="user-page-tab">
      <b-dropdown id="dropdown-1" variant="primary" text="Pilih Jenis Pengguna" class="m-md-2">
        <b-dropdown-item :active="$route.name === 'Daftar Owner'" href="#/pengaturan/pengguna/owner">Owner</b-dropdown-item>
        <b-dropdown-item :active="$route.name === 'Daftar Kasir'" href="#/pengaturan/pengguna/kasir">Kasir</b-dropdown-item>
        <b-dropdown-item :active="$route.name === 'Daftar Gudang'" href="#/pengaturan/pengguna/gudang">Gudang</b-dropdown-item>
      </b-dropdown> 
      <router-view></router-view>
    </div>
</template>

<script>
  import {VTab, VueTabs} from 'vue-nav-tabs'
  import 'vue-nav-tabs/themes/vue-tabs.scss'

  export default {
    components: {
      VueTabs,
      VTab
    },
    data () {
      return {
        role: this.$store.getters['account/accountData'].roles[0].name,
        tabValue: null,
        dataAccount: this.$store.getters['account/accountData']
      }
    },
    methods: {
      handleTabChange (tabIndex) {
        let url = null
        if (tabIndex === 0) {
          url = '/settings/users/admin'
        } else if (tabIndex === 1) {
          url = '/settings/users/ktu'
        } else if (tabIndex === 2) {
          url = '/settings/users/guru'
        } else if (tabIndex === 3) {
          url = '/settings/users/bendahara'
        } else if (tabIndex === 4) {
          url = '/settings/users/siswa'
        } else {
          url = '/settings/users/orang-tua'
        }
        this.$router.push({path: url})
      }
    }
  }
</script>

<style>
  #user-page-tab .card {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
  #user-page-tab .vue-tabs .nav-tabs {
    border-bottom: 0 solid #ddd;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Settings/Users/Index.vue